import { request } from '@/utils/request'


// 查询问诊列表
export function getScoreDetail(data) {
  return request({
    url: '/base/integral/openH5',
    method: 'post',
    data
  })
}

// 查询渠道是否有效
export function getIsValid(inviteSign) {
  return request({
    url: '/base/channelManage/check/' + inviteSign,
    method: 'get',
  })
}